<template>
    <el-card style="height: 100%" class="box-card" :body-style="{height: 'calc(100% - 110px)'}">
        <div slot="header" class="clearfix">
            <!-- 标题 -->
            <div style="display: flex;justify-content: space-between;align-items: center;">
                <span style="font-size: 24px">{{ $t('pzlb.批注列表') }}</span>
                <div style="width:400px" class="flexLR">
                    <el-input v-model="search" :placeholder="$t('pzlb.请输入关键字进行搜索')" @input="fuzzyQuery"
                        class="search-input"></el-input>
                    <el-button icon="el-icon-search" @click="fuzzyQuery"></el-button>
                </div>
            </div>
        </div>
        <div class="home">
            <el-table :data="pzList" border stripe height="100%">
                <el-table-column prop="projectfile.prfl02" :label="$t('pzlb.关联文件')" align="center">
                </el-table-column>
                <el-table-column prop="major" :label="$t('pzlb.专业')" align="center">
                </el-table-column>
                <el-table-column prop="type" :label="$t('pzlb.问题分类')" align="center">
                </el-table-column>
                <el-table-column prop="status" :label="$t('pzlb.状态')" align="center">
                    <template slot-scope="scope">
                        <el-dropdown :popper-append-to-body="false" trigger="click"
                            @command="(val) => updateStatus(val, scope.row)">
                            <span class="el-dropdown-link">
                                <span :style="{
                                    color:
                                        scope.row.status == '已修改' ? '#22b14c'
                                            : scope.row.status == '不修改' ? '#00a2e8'
                                                : scope.row.status == '已销项' ? '#000000'
                                                    : scope.row.status == '待修改' ? '#ed1c24'
                                                        : 'red',
                                    fontWeight: 500
                                }">[ {{ $t(`pzlb.${scope.row.status}`) }} ]</span>
                                <i class="el-icon-arrow-down el-icon--right"></i>
                            </span>
                            <el-dropdown-menu slot="dropdown" class="mydropdown">
                                <el-dropdown-item :command="$t('pzlb.待修改')" :disabled="scope.row.status == '待修改'">{{
                                    $t('pzlb.待修改') }}</el-dropdown-item>
                                <el-dropdown-item command="已修改" :disabled="scope.row.status == '已修改'">{{ $t('pzlb.已修改')
                                }}</el-dropdown-item>
                                <el-dropdown-item command="不修改" :disabled="scope.row.status == '不修改'">{{ $t('pzlb.不修改')
                                }}</el-dropdown-item>
                                <el-dropdown-item command="已销项" :disabled="scope.row.status == '已销项'">{{ $t('pzlb.已销项')
                                }}</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </template>
                </el-table-column>
                <el-table-column prop="description" :label="$t('pzlb.描述')" align="center">
                </el-table-column>
                <el-table-column prop="modifyname" :label="$t('pzlb.修改方')" align="center">
                </el-table-column>
                <el-table-column prop="creatname" :label="$t('pzlb.创建人')" align="center">
                </el-table-column>
                <el-table-column prop="time" :label="$t('pzlb.创建时间')" align="center">
                </el-table-column>
                <el-table-column width="250" :label="$t('pzlb.操作')" align="center">
                    <template slot-scope="scope">
                        <el-button type="primary" size="mini" @click="rowClick(scope.row)">{{ $t('pzlb.详情')
                            }}</el-button>
                        <el-button size="mini" @click="documentOpen(scope.row)">{{ $t('pzlb.打开') }}</el-button>
                        <el-button type="danger" size="mini" @click="delComment(scope.row)"
                            :disabled="scope.row.userId != $store.state.uid">{{ $t('pzlb.删除') }}</el-button>
                    </template>
                </el-table-column>
            </el-table>

        </div>

        <el-dialog :title="$t('pzlb.详情')" :visible.sync="mydialogVisible" width="30%" top="1%"
            :close-on-click-modal="true">
            <el-tabs v-model="activeName" @tab-click="tabsClick">
                <el-tab-pane :label="$t('pzlb.内容')" name="first" style="height:680px;overflow-y:auto;">
                    <div
                        v-if="activeItem && ($store.state.uid == activeItem.userId || (activeItem.modifyUsers && activeItem.modifyUsers.split(',').map(Number).includes($store.state.uid)))">
                        {{ $t('pzlb.问题回复') }}
                        <el-input :placeholder="$t('pzlb.请输入回复内容最多可输入200字')" :maxlength="200" :rows="4" type="textarea"
                            v-model="reply" style="width:100%;margin: 10px 0;" clearable>
                            <template #suffix></template>
                        </el-input>
                        <div style="margin-bottom: 10px;display: flex;justify-content: right;">
                            <el-button type="primary" size="small" @click="postMessage">{{ $t('pzlb.发表回复')
                                }}</el-button>
                        </div>
                    </div>

                    <div class="line"></div>

                    <div>
                        <!-- <el-image 
                            :preview-src-list="activeItem ? activeItem.files.filter(item => item.type == 1).map(item => $store.state.baseUrl + item.url) : []"
                            style="width: 115px; height: 100px;margin:0 10px 10px 0;"
                            v-for="(item, index) in activeItem ? activeItem.files.filter(item => item.type == 1) : []"
                            :key="index" :src="$store.state.baseUrl + item.url">
                        </el-image> -->
                        <el-carousel :autoplay="false" type="card" height="150px">
                            <el-carousel-item
                                v-for="(item, index) in activeItem ? activeItem.files.filter(item => item.type == 1) : []"
                                :key="index">
                                <el-image @click="resview(item)"
                                    :preview-src-list="activeItem ? activeItem.files.filter(item => item.type == 1).map(item => $store.state.baseUrl + item.url) : []"
                                    style="width: 300px; height: 150px;" :src="$store.state.baseUrl + item.url">
                                </el-image>
                            </el-carousel-item>
                        </el-carousel>
                    </div>

                    <el-descriptions class="margin-top" v-if="activeItem" style="padding-bottom: 40px;" :column="1">
                        <el-descriptions-item :label="$t('pzlb.所属文件')">{{ activeItem.projectfile ?
                            activeItem.projectfile.prfl02
                            :
                            '无'
                        }}</el-descriptions-item>
                        <el-descriptions-item :label="$t('pzlb.问题状态')">
                            <div style="color:red;cursor: pointer;">{{ $t(`pzlb.${activeItem.status}`) }}</div>
                        </el-descriptions-item>
                        <el-descriptions-item :label="$t('pzlb.问题描述')">{{ activeItem.description
                        }}</el-descriptions-item>
                        <el-descriptions-item :label="$t('pzlb.审图要点')">{{ activeItem.point }}</el-descriptions-item>
                        <el-descriptions-item :label="$t('pzlb.关联文件')">
                            <div style="width:100%;display:flex;justify-content:space-between;align-items:center;padding-right:10px;margin-bottom:5px"
                                v-for="item in (activeItem.files.length ? activeItem.files.filter(item => item.type == 2) : [])"
                                :key="item.id">
                                <span>{{ item.name }}</span>
                                <i class="el-icon-download" style="color:#409EFF;cursor: pointer;"
                                    @click="handlePreviewInfo(item)"></i>
                            </div>
                        </el-descriptions-item>
                        <el-descriptions-item :label="$t('pzlb.问题类型')">{{ activeItem.type }}</el-descriptions-item>
                        <el-descriptions-item :label="$t('pzlb.修改方')">{{ activeItem.modifyname }}</el-descriptions-item>
                        <el-descriptions-item :label="$t('pzlb.创建人')">{{ activeItem.creatname }}</el-descriptions-item>
                        <el-descriptions-item :label="$t('pzlb.创建时间')">{{ activeItem.createtime
                            }}</el-descriptions-item>
                        <el-descriptions-item :label="$t('pzlb.位置')">{{ activeItem.location ? activeItem.location : '无'
                            }}</el-descriptions-item>
                    </el-descriptions>
                    <!-- <el-button type="primary" size="default" style="width: 100%;position: fixed;bottom: 0;left: 0;">修改</el-button> -->
                </el-tab-pane>

                <el-tab-pane :label="$t('pzlb.活动')" name="second" style="height:680px;overflow-y:auto;">
                    <el-timeline>
                        <el-timeline-item v-for="item in RecordList" :key="item.id" :timestamp="item.time"
                            placement="top">
                            <el-card>
                                <h4>{{ item.username }}</h4>
                                <p>{{ $t('pzlb.状态') }}：{{ $t(`pzlb.${item.state}`) }}</p>
                                <p>{{ $t('pzlb.内容') }}：{{ item.content }}</p>
                            </el-card>
                        </el-timeline-item>
                    </el-timeline>
                </el-tab-pane>
            </el-tabs>
        </el-dialog>

    </el-card>
</template>

<script>
import {
    GetComment,
    DelComment, ChangeCommentState, AddCommentRecord, GetCommentRecord, AddRecentlyFile
} from "@/setAxios.js";
import dayjs from "dayjs";
import MyDialog from "@/components/Customization/dialog/index";
export default {
    name: "annotationList",
    components: {
        MyDialog
    },
    data() {
        return {
            search: "",
            pzList: [],
            AllPzList: [],
            visible: false,
            activeItem: null,
            mydialogVisible: false,
            activeName: "first",
            initPosition: { x: window.innerWidth / 2 - 220, y: 0 },
            RecordList: [],
            reply: "",
        };
    },
    created() {
        this.GetCommentList()
    },
    mounted() {
    },
    methods: {
        // 批注点击关联文件
        handlePreviewInfo(file) {
            const a = document.createElement('a');
            a.href = this.$store.state.baseUrl + file.url;
            a.download = file.name; // 设置默认文件名
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
        },
        async documentOpen(item) {
            AddRecentlyFile({ fileId: item.projectfile.guid, userId: this.$store.state.uid, time: dayjs().format("YYYY-MM-DD HH:mm:ss") })
            let params = `fileId=${item.projectfile.prfl01}&guid=${item.projectfile.guid}&path=${item.projectfile.prfl04}&xid=${item.projectfile.prfl05}&commentId=${item.id}&name=${item.projectfile.prfl02}`;
            params = Base64.encode(params);
            let url = window.location.origin + `/#/viewFileModel?Code=${params}`;
            window.open(url, "_blank");
        },
        // 点击列表行
        rowClick(row) {
            this.activeItem = row;
            this.mydialogVisible = true;
        },
        // 查询列表
        fuzzyQuery() {
            this.search = this.search.trim();
            if (this.search == '')
                this.pzList = this.AllPzList;
            else
                // this.pzList = this.AllPzList.filter(item => item.description.includes(this.search));
                this.pzList = this.AllPzList.filter(item =>
                    (item.description && item.description.includes(this.search))
                    || (item.point && item.point.includes(this.search))
                    || (item.major && item.major.includes(this.search))
                    || (item.creatname && item.creatname.includes(this.search))
                    || (item.modifyname && item.modifyname.includes(this.search))
                    || (item.time && item.time.includes(this.search))
                    || (item.projectfile && item.projectfile.prfl02.includes(this.search))
                    || (item.status && item.status.includes(this.search))
                    || (item.type && item.type.includes(this.search))
                );
        },
        // 批注详情活动页
        tabsClick(tab, name) {
            if (this.activeName == 'second') {
                let params =
                    { commentId: this.activeItem.id }
                GetCommentRecord({ params }).then(res => {
                    this.RecordList = res.Data;
                })
            }
        },
        // 批注详情回复
        postMessage() {
            if (this.reply == "") {
                this.$message.error(this.$t('common.请输入内容'))
                return
            } else {
                let params = { commentId: this.activeItem.id, content: this.reply }
                AddCommentRecord(params).then(res => {
                    this.$message.success(this.$t('common.处理成功'))
                    this.reply = "";
                })
            }
        },
        // 更新批注列表状态
        updateStatus(state, item) {
            let params = { commentId: item.id, state }
            ChangeCommentState(params).then(res => {
                this.$message.success(this.$t('common.处理成功'))
                this.GetCommentList()
            })
        },
        // 删除批注列表的信息
        delComment(item) {
            DelComment({ id: item.id }).then(res => {
                this.$message.success(this.$t('common.处理成功'))
                this.GetCommentList()
            })
        },
        GetCommentList() {
            let params = { xid: localStorage.xid };
            GetComment({ params }).then(res => {
                this.pzList = res.Data;
                this.AllPzList = res.Data;
            })
        },
    }
};
</script>

<style lang="less" scoped>
.home {
    width: 100%;
    height: 100%;

    .el-cascader {
        width: 100%;
    }

    .dialog2 {
        /deep/ .el-descriptions__header {
            margin-bottom: 15px !important;
        }


        /deep/ .el-descriptions {
            margin-bottom: 8px;
            background-color: #ebf9ff;
            padding: 8px;
            border-radius: 6px;
        }


        /deep/ .el-descriptions__body {
            background-color: transparent;
        }

    }

    /deep/ .el-tabs__nav-scroll {
        display: flex;
        justify-content: center;
    }

    /deep/ .el-descriptions-item__content {
        flex-wrap: wrap;
        justify-content: space-between;
    }

    .line {
        height: 1px;
        width: 100%;
        background-color: rgb(226, 226, 226);
        margin: 10px 0;
    }
}


.flexLR {
    display: flex;
    justify-content: space-around;
    align-items: center;
}

/deep/ .el-upload--picture-card {
    width: 75px;
    height: 75px;
    line-height: 75px;
}

/deep/ .el-descriptions-item__content {
    flex-wrap: wrap;
    justify-content: space-between;
}

/deep/ .el-tabs__nav-scroll {
    display: flex;
    justify-content: center;
}
</style>